import {Component, EventEmitter, HostBinding, Input, Output} from '@angular/core';
import {TranslateModule} from "@ngx-translate/core";

@Component({
    selector: 'save-button',
    imports: [
        TranslateModule
    ],
    standalone: true,
    templateUrl: './save-button.component.html',
    styleUrls: ['./save-button.component.css']
})
export class SaveButtonComponent {
    @Input() disabled: boolean | null = true;
    @Output() click = new EventEmitter<void>();

    @HostBinding('class.disabled') get isDisabled() {
        return this.disabled;
    }
    @HostBinding('class.btn') btnClass = true;
    @HostBinding('class.btn-success') btnSuccessClass = true;
}
